import React, { useState, useEffect, FC } from "react"
import UserLink from "../../utils/UserLink"
import { storage } from "../../firebase"
import { User } from "../../models/user"

const ArtistCard: FC<{ user: User }> = ({ user }) => {
  const { username, fans } = user
  const [profile, setProfile] = useState("")

  useEffect(() => {
    let mounted = true

    storage
      .ref(`profiles/${user.id}`)
      .getDownloadURL()
      .then((url) => {
        if (mounted) {
          setProfile(url)
        }
      })
      .catch((er) => {})

    return () => {
      mounted = false
    }
  })
  return (
    <div
      className="fa-card white-text"
      uk-scrollspy="cls:uk-animation-scale-up uk-animation-slide-left-small"
    >
      <div
        className="aimage"
        style={{ background: profile ? `url(${profile})` : `#ddd` }}
      ></div>
      <div>
        <div className="fa-name">
          <UserLink params={{ username }}>@{username}</UserLink>
        </div>

        <div className="fa-details">
          <div>
            {fans.length} {fans.length === 1 ? "fan" : "fans"}
          </div>
          <span>.</span>
          <div>{Math.floor(Math.random() * 12)} tracks</div>
        </div>
      </div>
    </div>
  )
}

export default ArtistCard
